module.exports = __webpack_public_path__ + "static/media/eddykenzo.a2205eb1.jpg";